import { Form } from "@/atoms"
import { TFunction, useTranslation } from "@/hooks/useTranslation"
import { ClearableInputNumber } from "@/molecules/ClearableInputNumber"
import React from "react"
import { JiraFormItem } from "../../JiraFormItem"
import { JiraFormItemProps } from "../../JiraIssueField.types"
import { calculateOnDemandDateFieldHint, formatFieldName } from "../../helpers"
import styles from "./OnDemandDateField.module.scss"

export const OnDemandDateField: React.FC<
  Omit<JiraFormItemProps, "children" | "fieldHint" | "formItemName"> & {
    fieldName: string
    formItemPrefix: string
    t: TFunction
    disabled?: boolean
  }
> = ({ fieldName, formItemPrefix, t, disabled, ...props }) => {
  const formattedFieldName = formatFieldName(fieldName)
  const fieldItemPrefix = [formItemPrefix, formattedFieldName]
  const formItemName = [...fieldItemPrefix, "value"]
  const { t: tGeneral } = useTranslation()
  const form = Form.useFormInstance()
  const value = Form.useWatch(formItemName, form)

  const dayTrans = tGeneral("general.day", { count: value || 0 })
  const fieldHint = calculateOnDemandDateFieldHint({
    value,
    fieldName,
    dayTrans,
    t,
    isRequired: props.required || false
  })

  return (
    <div className={styles.wrapper}>
      <JiraFormItem
        fieldHint={fieldHint}
        formItemName={formItemName}
        {...props}
      >
        <ClearableInputNumber
          disabled={disabled}
          className={styles.inputNumber}
          onChange={() =>
            form.resetFields([
              [...fieldItemPrefix, "key"],
              [...fieldItemPrefix, "type"]
            ])
          }
          min={0}
          allowClear
          suffix={dayTrans}
          type="number"
        />
      </JiraFormItem>
      <Form.Item
        name={[...fieldItemPrefix, "key"]}
        initialValue={props.fieldKey}
        hidden
      />
      <Form.Item
        name={[...fieldItemPrefix, "type"]}
        initialValue="date"
        hidden
      />
    </div>
  )
}
